import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'breakSpaces' })
export class BreakSpacesPipe implements PipeTransform {
  transform(inputString?: string): string {
    const regex = /\n/gm;
    return inputString?.replace(regex, '<br>');
  }
}
